import CarrierActiveView from './CarrierActiveView';

export default CarrierActiveView;
